<template>
    <div>
        <div v-if="localIsInFav" class="item"><img class="item__icon" :src="this.localBaseUrl + '/img/fav_on.png'" alt=""/>
            <a @click="removeFromFav" class="item__link" title="Удалить из избранного" href="#">Удалить из избранного</a>
        </div>
        <div v-else class="item"><img class="item__icon" :src="this.localBaseUrl + '/img/fav_off.png'" alt=""/>
            <a @click="addToFav" class="item__link" title="Добавить в избранное" href="#">В избранное</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "product-fav",
        props: {
            product_id: {
                type: Number
            },
            baseurl: {
                type: String
            },
            is_infav: {
                type: Boolean,
            }
        },
        data() {
            return {
                localProductId: this.product_id,
                localBaseUrl: this.baseurl,
                localIsInFav: this.is_infav,
            }
        },
        methods: {
            addToFav(e) {
                e.preventDefault();
                this.$store.dispatch("addToFav", {
                  product_id: this.product_id
                })
                this.localIsInFav = true;
            },
            removeFromFav(e) {
                e.preventDefault();
                this.$store.dispatch("removeFromFav", {
                  product_id: this.product_id
                })
                this.localIsInFav = false;
            }
        },
    }
</script>

<style scoped>

</style>